export { default as HeadingText } from './HeadingText';
